import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { BzTabsContent, BzTabsContainer, BzChip } from "../../components";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router';
import { Walkthrough } from '../Help';
import { useDispatch, useSelector } from 'react-redux';
import { COUNTS, DASHBOAR_WALKTHROUGH_POPOVER_SEQUENCE, LOCATIONS, ORDER_TYPES, SESSION_STORAGE_KEYS } from "../../utils/global_variables";
import { clearAllOpenOrders, getAllMultiScripOrders, getAllOpenOrders, getAllSpreadOrders, updateActiveOrders } from '../../redux/actions/orders';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import { isGuestUser, isUserIsAGuest } from '../../utils/global_functions';



const OpenOrders = ({ arrOpenOrders, activeTabId }) => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
    const { allOpenOrders } = useSelector(state => state?.orders?.getSpreadOrder);
    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End

    const { orderTypes } = useSelector(state => state.orders);

    const handleOrders = useCallback((objOrdersTypes) => {
        const selectedOrderType = orderTypes.find(orderType => orderType?.id === objOrdersTypes?.id);
        dispatch(updateActiveOrders(selectedOrderType));
    }, [dispatch, orderTypes]);


    // Vinit Raut : 17-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- Start  
    const singleOrdersCount = useMemo(() => orderTypes[0]?.metadata?.open_records || 0, [orderTypes]);
    const multiOrdersCount = useMemo(() => orderTypes[1]?.metadata?.open_records || 0, [orderTypes]);
    const sipOrdersCount = useMemo(() => orderTypes[2]?.metadata?.open_records || 0, [orderTypes]);
    const gtdOrdersCount = useMemo(() => orderTypes[3]?.metadata?.open_records || 0, [orderTypes]);
    const spreadOrdersCount = useMemo(() => allOpenOrders?.metadata?.open_records || 0, [allOpenOrders]);
    // Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start  


    const routeChange = () => {
        if (!isUserIsAGuest('orders')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            let sectionPath = '';
            if (activeTabId === COUNTS.ONE) sectionPath = ORDER_TYPES.SINGLE_SCRIP;
            else if (activeTabId === COUNTS.TWO) sectionPath = ORDER_TYPES.MULTI_LEG;
            else if (activeTabId === COUNTS.THREE) sectionPath = ORDER_TYPES.EQUITY_SIP;
            else if (activeTabId === COUNTS.FOUR) sectionPath = ORDER_TYPES.GOOD_TILL_DATE;
            else if (activeTabId === COUNTS.FIVE) sectionPath = ORDER_TYPES.SPREAD;

            const path = `/orders?section=${sectionPath}&ordertype=open_orders`;
            navigate(path);
            sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    };

    const location = useLocation();

    function getOrdersCount(id) {
        if (id === COUNTS.ONE) return singleOrdersCount;
        else if (id === COUNTS.TWO) return multiOrdersCount;
        else if (id === COUNTS.THREE) return sipOrdersCount;
        else if (id === COUNTS.FOUR) return gtdOrdersCount;
        else if (id === COUNTS.FIVE) return spreadOrdersCount;
    }
    // Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End  

    // Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start

    const [pageNo, setPageNo] = useState(1);
    const targetDiv = useRef(null);
    const [isNearBottom, handleScroll] = useInfiniteScroll(targetDiv, 100);

    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- Start 
    useEffect(() => {
        if (!isGuestUser()) {

            const limit = 20;
            dispatch(clearAllOpenOrders());
            dispatch(getAllOpenOrders({ offSet: pageNo, limit: limit, orderType: [{ orderType: 'spread', offSet: pageNo, limit, orderStatus: 1 }, { orderType: 'multileg', offSet: pageNo, limit, orderStatus: 1 }], orderStatus: 1 }));
            dispatch(getAllSpreadOrders({ offSet: 1, limit: 20, spread: true, orderStatus: -1 }));
            dispatch(getAllMultiScripOrders({ offSet: 1, limit: 20, multileg: true, orderStatus: -1 }));
            // On mount set open orders active tab to single scrip
            const selectedOrderType = orderTypes.find(orderType => orderType?.id === 1);
            dispatch(updateActiveOrders(selectedOrderType));
        } else {
            dispatch(updateActiveOrders({ id: 1 }));
        }

        return () => dispatch(clearAllOpenOrders());
    }, [dispatch]);

    useEffect(() => {
        if (isNearBottom) {
            const limit = 20;
            setPageNo(prev => prev + 1);
            if (!isGuestUser()) {
                dispatch(getAllOpenOrders({ activeScripId: activeTabId, offSet: pageNo + 1, limit, orderType: [{ orderType: 'spread', offSet: pageNo + 1, limit, orderStatus: 1 }, { orderType: 'multileg', offSet: pageNo + 1, limit, orderStatus: 1 }], orderStatus: 1 }));
            } else { }
        } else { }
    }, [isNearBottom]);
    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- End 

    useEffect(() => {
        setPageNo(1);
    }, [activeTabId]);
    // Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End


    return (
        <Container fluid className='p-0'>
            <Walkthrough orderNo={DASHBOAR_WALKTHROUGH_POPOVER_SEQUENCE.OPEN_ORDERS}  >
                {
                    location.pathname === LOCATIONS.DASHBOARD ?
                        <>
                            <div>
                                <Row className='g-0 px-3 dashboard-cards-header align-items-center'>
                                    <Col md={10} className='d-flex justify-content-start'>
                                        <div className='font-regular font-size6 color-text'>Open Orders</div>
                                    </Col>
                                    <Col md={2} className='d-flex justify-content-end'>
                                        <div className='background-icon' onClick={routeChange}>
                                            <div className='icon-16 icon-forward-arrow icon-dark'></div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='dashboard-cards-container p-3'>
                                    <Row className='g-0'>
                                        <Col>
                                            <div className='submenu-wrapper horizontal-scroll-wrap py-1'>
                                                {arrOpenOrders.map((each, i) => (
                                                    <BzChip key={each.tabKey} className={`submenuItem ${each?.id === activeTabId ? 'active' : ''}`}
                                                        onClick={() => handleOrders(each)}>
                                                        {/* Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */}
                                                        {`${each?.title} (${getOrdersCount(each?.id)})`}
                                                        {/* Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */}
                                                    </BzChip>
                                                ))}

                                            </div>
                                        </Col>
                                    </Row>
                                    <div onScroll={handleScroll} ref={targetDiv} className='order-card-wrapper'>
                                        <BzTabsContainer>
                                            {
                                                arrOpenOrders.map((each, i) => (
                                                    <BzTabsContent key={i} tabKey={each?.id ? each?.id?.toString() : ''} showDefault={each?.id === activeTabId} isActive={each?.id === activeTabId} >{each?.chipContent}</BzTabsContent>
                                                ))
                                            }
                                        </BzTabsContainer>
                                    </div>
                                </div>
                            </div>
                        </> : (
                            <div className='order-card-wrapper'>
                                <BzTabsContainer>
                                    {
                                        arrOpenOrders.map((each, i) => (
                                            <BzTabsContent key={i} tabKey={each?.id ? each?.id?.toString() : ''} showDefault={each?.id === activeTabId} isActive={each?.id === activeTabId} >{each?.chipContent}</BzTabsContent>
                                        ))
                                    }
                                </BzTabsContainer>
                            </div>
                        )
                }
            </Walkthrough>
        </Container>
    );
};

export default memo(OpenOrders);